import './webcomponents/PcoStubNested.wc';

const root = document.getElementById('root');
if (root) {
  root.innerHTML = '<pco-stub-element-nested version="0.0.1"></pco-stub-element-nested>';
}
